import { render, staticRenderFns } from "./MemberSetting.vue?vue&type=template&id=9007c6c4&scoped=true&"
import script from "./MemberSetting.vue?vue&type=script&lang=js&"
export * from "./MemberSetting.vue?vue&type=script&lang=js&"
import style0 from "./MemberSetting.vue?vue&type=style&index=0&id=9007c6c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9007c6c4",
  null
  
)

export default component.exports